import {
  Grid,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spacer
} from '@chakra-ui/react'
import { FC, SetStateAction, useEffect, useState } from 'react'

import useReabRoutes from '@hook/parametrization/use-reab-routes'
import useReabTimeline from '@hook/parametrization/use-reab-timeline'
import useReabTypeVeichule from '@hook/parametrization/use-reab-typeveichule'
import useAuth from '@hook/shared/use-auth'
import useFilters from '@hook/shared/use-filters'

import Layout from '@component/Layout'
import Filter from '@component/Shared/Filter'

import CronogramaReab from './ReabConfig/CronogramaReab'
import ParametrizationReabLevelOne from './ReabConfig/LevelOneRoutes'
import ParametrizationReabTypeVeichule from './ReabConfig/ParametrizationReabTypeVeichule'

const ConfigReabView: FC = () => {
  const { getFilters, loading } = useFilters()
  const { companies: authCompanies } = useAuth()
  const { companies, distributionCenters } = useFilters()
  const { companieId, handleCompanieId } = useReabTimeline()
  const { handleCompanieIdTypeOfVeichule, companieId: companieIdType } =
    useReabTypeVeichule()
  const { handleRouteVeichule, companieId: companieIdRoute } = useReabRoutes()
  const [tabIndex, setTabIndex] = useState(0)

  const handleTabsChange = (index: SetStateAction<number>) => {
    setTabIndex(index)
  }
  useEffect(() => {
    // if (authCompanies?.length === 1) {
    //   getData(authCompanies[0])
    // }

    // data?.length === 0 && getData()
    getFilters({
      companies: true,
      centers: true,
      distributionCenters: true
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Reab">
      <Grid w="50vw" bg="white" h="40vh" templateColumns="95vw">
        <Box>
          <Tabs
            variant="soft-rounded"
            colorScheme="green"
            index={tabIndex}
            onChange={handleTabsChange}
          >
            <TabList>
              <Tab>Cronograma</Tab>
              <Tab>Tipo Veículo</Tab>
              <Tab>Rotas</Tab>
              <Spacer />
              {tabIndex === 1 && authCompanies?.length > 1 && (
                <Box w={300} pt={4} pr={4}>
                  <Filter
                    label=""
                    options={companies}
                    isMulti={false}
                    value={[
                      companies.find(
                        company => company.value === companieIdType
                      )
                    ]}
                    onChange={values => {
                      handleCompanieIdTypeOfVeichule(values)
                      handleRouteVeichule(values)
                    }}
                    isLoading={loading}
                  />
                </Box>
              )}
              {tabIndex === 0 && authCompanies?.length > 0 && (
                <Box w={300} pt={4} pr={4}>
                  <Filter
                    label=""
                    options={distributionCenters}
                    isMulti={false}
                    value={[
                      distributionCenters.find(
                        distributionCenters =>
                          distributionCenters.value === companieId
                      )
                    ]}
                    onChange={values => {
                      handleCompanieId(values)
                    }}
                    isLoading={loading}
                  />
                </Box>
              )}
              {tabIndex === 2 && authCompanies?.length > 1 && (
                <Box w={300} pt={4} pr={4}>
                  <Filter
                    label=""
                    options={companies}
                    isMulti={false}
                    value={[
                      companies.find(
                        company => company.value === companieIdRoute
                      )
                    ]}
                    onChange={values => {
                      handleCompanieIdTypeOfVeichule(values)
                      handleRouteVeichule(values)
                    }}
                    isLoading={loading}
                  />
                </Box>
              )}
            </TabList>
            <TabPanels>
              <TabPanel>
                <CronogramaReab />
              </TabPanel>

              <TabPanel>
                <ParametrizationReabTypeVeichule />{' '}
              </TabPanel>
              <TabPanel>
                <ParametrizationReabLevelOne />{' '}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Grid>
    </Layout>
  )
}

export default ConfigReabView
